import { RawCalcTrainDataViewModel } from "src/app/models/OpRawCalc.model";

export class CustomGraphConfigData {
    trainId: number = 0
    plantId: number = 0
    stage: number = 1
    unit:number =0
    projectNo: number = 0
    showSystemConfig: string = "No";
    trainList: DropDownList[]
    stageTotal:number = 0;
}

export class DropDownList {
    label: string = ""
    value: number = 0
    stages: number = 0
    sysConfigStr: string = ""
}


export class AllTrainData {
    List1: RawCalcTrainDataViewModel[];
    List2: RawCalcTrainDataViewModel[];
    List3: RawCalcTrainDataViewModel[];
    List4: RawCalcTrainDataViewModel[];
    List5: RawCalcTrainDataViewModel[];

}
